import { getUserFolders } from '@/api/folder'
import { useQuery } from '@tanstack/react-query'

export function useUserFolders() {
  const {
    data: foldersData,
    isLoading: isLoadingFolders,
    isError,
    refetch,
  } = useQuery({
    queryKey: ['folders'],
    queryFn: () =>
      getUserFolders({
        page: 1,
        items_per_page: 100,
      }),
    refetchOnWindowFocus: true,
    gcTime: 0,
  })

  const folders = foldersData?.folders ?? []

  return {
    folders,
    isLoadingFolders,
    isError,
    refetch,
  }
}
